var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"title":"Save as JSON"},on:{"click":_vm.saveFavlists}},[_c('Icon',[_c('JsonIcon')],1),_c('Icon',[_c('DownloadIcon')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }